let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4UCFb")).then(() => parcelRequire('lxcD5'));